<template>
  <div>
    <el-card>
      <el-row class="mb-16" type="flex">
        <el-col :span="12" v-auth="'stores::product-manager::attr-add'">
          <el-button @click="addProp" icon="el-icon-plus" type="primary" v-auth="'stores::product-manager::attr-add'">
            {{ $t('product-manager::prop::add_button') }}
          </el-button>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <span>{{ $t('product-manager::prop::search') }}：</span>
          <el-input
            :placeholder="$t('product-manager::prop::placeholder_search')"
            @keyup.enter.native="handleSearch"
            class="search-input"
            prefix-icon="el-icon-search"
            v-model.trim="searchData.optionName"
          ></el-input>
        </el-col>
      </el-row>
      <z-table
        :columns="columns"
        :data="tableData"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
        height="540px"
        ref="table"
        v-loading="loading"
      >
        <template #operate="{ row }">
          <span>
            <el-button @click="handleEdit(row)" type="text" v-auth="'stores::product-manager::attr-edit'">
              {{ $t('product-manager::prop::table_edit') }}
            </el-button>
            <!-- <el-button
              @click="handleProperty(row)"
              type="text"
              v-auth="'stores::product-manager::attr-edit'"
              v-if="row.type === 2"
            >{{ $t('product-manager::prop::table_prop') }}</el-button>-->
            <el-button
              @click="handleDel(row)"
              style="color: red"
              type="text"
              v-auth="'stores::product-manager::attr-delete'"
            >
              {{ $t('product-manager::prop::table_delete') }}
            </el-button>
          </span>
        </template>
      </z-table>
    </el-card>
    <edit-dialog :isEdit="isEdit" @updateData="handleAddProp" ref="edit"></edit-dialog>
    <attrDraw :drawRow="drawRow" v-model="drawerVisable"></attrDraw>
  </div>
</template>
<script>
import { CUSTOMER_COLUMNS, data } from './config/index'
import EditDialog from './components/editDialog'
import attrDraw from './components/attr-draw'
import { getAttrListPage, updateProp, deleteProp } from '@/server/product'
export default {
  components: {
    EditDialog,
    attrDraw,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchProp: '',
      drawRow: {
        type: 'write',
        item: {},
      },
      drawerVisable: false,
      isEdit: false,
      searchData: {
        optionName: '',
      },
      columns: CUSTOMER_COLUMNS,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0,
      },
    }
  },
  mounted() {
    this.getPropListData()
  },
  methods: {
    async getPropListData() {
      this.loading = true
      const { data } = await getAttrListPage({ ...this.pagination, ...this.searchData })
      if (data.code === this.$code) {
        this.tableData = data.data.items
        this.pagination.total = data.data.totalCount
      }
      this.loading = false
    },
    async deletePropHandle(id) {
      const { data } = await deleteProp(id)
      if (data.code === this.$code) {
        this.$message({
          type: 'success',
          message: this.$t('system::tip::delete_success'),
        })
        this.getPropListData()
      }
    },
    handleAddProp() {
      // 新增数据后 更新数据
      this.getPropListData()
    },
    handlePageChange() {
      this.getPropListData()
    },
    handleProperty(row) {
      if (row) {
        this.drawRow.item = row
      }
      this.drawerVisable = true
    },
    handleEdit(row) {
      this.isEdit = true
      if (!row.values) row.values = []
      this.$refs.edit.show(row)
    },
    handleDel(row) {
      this.$confirm(
        this.$t('product-manager::prop::delete_tip'),
        this.$t('system::common::dialog::change_merchant_tooltip'),
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
        }
      )
        .then(() => {
          this.deletePropHandle(row.id)
          // this.getPropListData()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    handleSearch() {
      this.getPropListData()
    },
    addProp() {
      this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增属性' })
      this.isEdit = false
      this.$refs.edit.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.search-input {
  width: 180px;
}
.mb16 {
  margin-bottom: 16px;
}
.searchArea {
  display: flex;
  justify-content: space-between;
  .searchProp {
    display: flex;
    justify-content: space-around;
    .propName {
      width: 35%;
      line-height: 40px;
      font-size: 15px;
      // margin-right: 10px;
    }
    // .el-input-group__append {
    //   background-color: #0560FD;
    //   .searchBtn {
    //     color: #fff;
    //     border: none;
    //     background-color: #0560FD;
    //   }
    // }
  }
}
</style>
